import Box from '@mui/material/Box'
import { ReactChild } from 'react'

interface Props {
  title: string
  children: ReactChild
}

const SelectorBox = ({ title, children }: Props) => (
  <Box
    display="flex"
    flexDirection="column"
    p={1}
    ml={1}
    mr={1}
    bgcolor="grey.100"
    border={1}
    borderColor="grey.200"
  >
    <Box p={1} mb={1} bgcolor="grey.300" border={1} borderColor="grey.200">
      {title}
    </Box>
    {children}
  </Box>
)

export default SelectorBox
